define('payment/handlers/paymentMethodHandlers/creditCardMethodHandler',['jquery'], function ($) {
	'use strict';

	function disableNonNumericCharacters($element) {
		$element.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = String.fromCharCode(event.which);
			if ('1234567890'.indexOf(chr) < 0 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

	function disableNumericCharacters($element) {
		$element.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = String.fromCharCode(event.which);
			if ('1234567890.,;:<>/|\\!?@#$%^&*(){}[]_+=-\"\'~`'.indexOf(chr) >= 0 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

	function disableSingleQuoteCharacter($element) {
		// OBS. This method has written BEFORE the disableNumericCharacters() method enhanced to filter out punctuations. So it's kind of redundant
		$element.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = event.which; // 39 == single quote
			if (chr == 39 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

	function setupFormTemplate(paymentBox) {
		var $box = paymentBox.$box,
			$creditCardNumber = $box.find('[name="cn"]'),
			$creditCardVerificationCode = $box.find('[name="cc"]'),
			$creditCardOwner = $box.find('[name="co"]');

		disableNonNumericCharacters($creditCardNumber);
		disableNonNumericCharacters($creditCardVerificationCode);
		disableNumericCharacters($creditCardOwner);
		disableSingleQuoteCharacter($creditCardOwner);
	}

	return {
		setupFormTemplate: setupFormTemplate
	};
});

